import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { scrollToSection } from "@/lib/scrollTo";
import { IMAGES } from "@/data/content";

export const TechnologyHero = () => {
  const navigate = useNavigate();

  return (
    <section
      data-testid="technology-hero-section"
      className="bg-baseLight px-6 pt-[130px] pb-[30px] sm:pt-[150px] sm:pb-[40px] lg:px-12 lg:pt-[190px] lg:pb-[70px]"
    >
      <div className="lg:mx-auto lg:max-w-[1280px]">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-7"
          >
            <span data-testid="technology-hero-eyebrow" className="text-sm font-medium text-teal">
              TECHNOLOGY
            </span>
            <h1
              data-testid="technology-hero-headline"
              className="mt-3 font-heading text-[34px] font-semibold leading-[1.15] text-ink sm:text-[46px] lg:text-[55px]"
            >
              Renewable energy when it's available. Stored energy when it isn't.
            </h1>
            <p
              data-testid="technology-hero-text"
              className="mt-[32px] lg:mt-6 max-w-xl text-[15px] leading-relaxed text-inkSoft lg:max-w-[540px]"
            >
              Solar and wind generation, battery buffering and hydrogen storage work together
              to support farm loads through changing conditions and extended outages.
            </p>
            <div className="mt-8 flex flex-wrap items-center gap-x-7 gap-y-4">
              <button
                type="button"
                data-testid="technology-hero-cta-primary"
                onClick={() => scrollToSection("#architecture")}
                className="inline-flex h-11 items-center bg-teal text-white text-sm font-medium rounded-full px-6 hover:bg-tealHover transition-all duration-300 hover:-translate-y-0.5"
              >
                Explore the System
              </button>
              <button
                type="button"
                data-testid="technology-hero-cta-secondary"
                onClick={() => navigate("/#contact")}
                className="group inline-flex items-center gap-1.5 text-sm text-inkSoft hover:text-teal transition-colors duration-300"
              >
                <span className="underline decoration-borderSubtle group-hover:decoration-teal/60 transition-colors duration-300">
                  Request an Energy Assessment
                </span>
                <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5" />
              </button>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.97 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-5"
          >
            <div data-testid="technology-hero-visual" className="h-[280px] w-full overflow-hidden rounded-2xl sm:h-[340px] lg:h-[374px]">
              <img
                src={IMAGES.technologyHero}
                alt="Engineer reviewing hydrogen energy equipment"
                className="h-full w-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
